export default "__VITE_ASSET__21091480__"